import { render, staticRenderFns } from "./HumanResourceMenu.vue?vue&type=template&id=2a22a2c1"
import script from "./HumanResourceMenu.vue?vue&type=script&lang=js"
export * from "./HumanResourceMenu.vue?vue&type=script&lang=js"
import style0 from "./HumanResourceMenu.vue?vue&type=style&index=0&id=2a22a2c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports